// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as HeaderVm$PorterinFeature from "../vm/HeaderVm.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as HeaderStore$PorterinFeature from "../vm/HeaderStore.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../containers/login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LogoComponent$PorterinFeature from "./LogoComponent.mjs";
import * as HeaderV2ModuleScss from "../styles/HeaderV2.module.scss";
import * as OrderReviewHelper$PorterinFeature from "../../../../containers/order-review/domain/helpers/OrderReviewHelper.mjs";
import * as OrderHistoryHelper$PorterinFeature from "../../../../containers/order-history/domian/helpers/OrderHistoryHelper.mjs";
import * as PrimaryLinksComponent$PorterinFeature from "./PrimaryLinksComponent.mjs";
import * as SecondaryLinksComponent$PorterinFeature from "./SecondaryLinksComponent.mjs";

var styles = HeaderV2ModuleScss;

function HeaderLinksCmp(Props) {
  var data = Props.data;
  var match = React.useState(function () {
        return false;
      });
  var match$1 = HeaderVm$PorterinFeature.getVm(data);
  var links = match$1.links;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery(MediaQuery$PorterinUtils.minWidthDesktop);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$2 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var order_history = match$2.order_history;
  var onTrackHandler = function (param) {
    var match = OrderHistoryHelper$PorterinFeature.countOfLiveOrder(order_history) > 1;
    var match$1 = OrderHistoryHelper$PorterinFeature.isCourierOrder(order_history, 0);
    if (match) {
      return JsBindings$PorterinUtils.redirect(Config$PorterinUtils.oms_url + HeaderStore$PorterinFeature.orderHistoryPath);
    } else if (match$1) {
      return OrderReviewHelper$PorterinFeature.courierTrackingLinkRedirect(OrderHistoryHelper$PorterinFeature.orderCrn(order_history, 0));
    } else {
      return OrderReviewHelper$PorterinFeature.allocationLinkRedirect(OrderHistoryHelper$PorterinFeature.orderCrn(order_history, 0));
    }
  };
  return React.createElement(React.Fragment, undefined, React.createElement(LogoComponent$PorterinFeature.make, {
                  citySelectedContext: citySelectedContext,
                  logo: match$1.logo,
                  isDesktop: isDesktop
                }), React.createElement(PrimaryLinksComponent$PorterinFeature.make, {
                  for_enterprise_link: links.for_enterprise_link,
                  driver_partner_link: links.driver_partner_link
                }), React.createElement(SecondaryLinksComponent$PorterinFeature.make, {
                  is_authenticated: match$2.is_authenticated,
                  order_history: order_history,
                  onTrackHandler: onTrackHandler,
                  set_user: match$2.set_user,
                  set_is_authenticated: match$2.set_is_authenticated,
                  set_is_mobile_menu_open: match[1],
                  support_link: links.support_link,
                  language_selector: data.language_selector
                }));
}

var Link;

var make = HeaderLinksCmp;

export {
  styles ,
  Link ,
  make ,
}
/* styles Not a pure module */
